import { createContext } from 'react';
import { ActivityAnalyticsItem } from '@/api';

export interface TasksAndAlertsUserActivityContextData {
    status: 'error' | 'success' | 'pending';
    activity: ActivityAnalyticsItem[];
    dateString: string | null;
}

export const TasksAndAlertsUserActivityContext = createContext<
    TasksAndAlertsUserActivityContextData | undefined
>(undefined);
